export default __webpack_public_path__ + "static/media/project-img-6.566e745a.png";